import * as React from 'react';

import WidgetLink from './WidgetLink';

import { AvailableWidget } from '../../store/models';

interface IWidgetMenuProps {
    availableWidgets: AvailableWidget[],
    widgetUsageCounts: Object,
    onClick: Function
}

export default class WidgetMenu extends React.Component<IWidgetMenuProps, void> {
    static propTypes = {
        availableWidgets: React.PropTypes.array.isRequired,
        widgetUsageCounts: React.PropTypes.object.isRequired,
        onClick: React.PropTypes.func.isRequired
    };

    render() {
        const { availableWidgets, widgetUsageCounts } = this.props;

        return (
            <ul className="nav nav-sidebar">
                {availableWidgets.map(this.renderWidget.bind(this))}
            </ul>
        );
    }

    renderWidget(widget: AvailableWidget) {
        const usageCount = this.getWidgetUsageCount(widget);
        const isDisabled = usageCount >= widget.maxPossibleUsage;
        const { onClick } = this.props;

        let classname:string = '';
        if(widget.id.split('.')[0]==='PM'){
            classname='hide';
        }else if(widget.id.split('.')[0]==='MAV'){
            classname='hide';
        }
        if (isDisabled){classname=classname+'disabled'}

        return (
            <li key={widget.id} className={classname}>
                <WidgetLink onLinkClick={() => onClick(widget)} color={widget.color} disabled={isDisabled}>
                    {widget.displayName}
                    <span className={this.getBadgeClasses(widget)}>{this.getWidgetUsageCount(widget)}</span>
                </WidgetLink>
            </li>
        );
    }

    getWidgetUsageCount(widget: AvailableWidget): number {
        const { widgetUsageCounts } = this.props;
        return widgetUsageCounts[widget.type] || 0;
    }

    getBadgeClasses(widget: AvailableWidget): string {
        let color = this.getWidgetUsageCount(widget) < widget.maxPossibleUsage ? 'default' : 'warning';
        return `label label-${color} pull-right`;
    }
}


// WEBPACK FOOTER //
// ./src/components/widgetMenu/WidgetMenu.tsx